module.exports = "https://trybtryb-legacy.web.app/img/spotify.a18ae5f4.svg";